import React, { Component } from "react";
import { Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  Container,
  Header,
  toaster,
  Heading,
  Button,
  Input,
  Message,
} from "rsuite";
import html3pdf from "html3pdf";
import axios from "../axiosIn";

const options = {
  filename: "CartaResponsiva.pdf",
  FontFace: "Arial",
  margin: 0,
  image: { type: "jpeg", quality: 0.98 },
  html2canvas: { scale: 1 },
  jsPDF: { unit: "in", format: "letter", orientation: "landscape" },
};

export class DescargaCarta extends Component {
  constructor(props) {
    super(props);

    this.myRef = React.createRef();
    this.state = {
      disabledBtn: false,
      loading: false,
      disabledPdf: true,
      display: "none",
      fecha: "",
      nombre: "",
      categoria: "",
      fecNac: "",
      edad: 0,
      clave: "",
      curp: "",
      equipo: "",
      numero: 0,
      tel: "",
      lblCurp: "",
      logo: this.getCookie("logo"),
      pista: this.getCookie("pista")
    };
  }

  toast(msg, type = "info") {
    toaster.push(
      <Message showIcon type={type} closable>
        <strong>{type}!</strong>
        &nbsp; {msg}
      </Message>,
      { duration: 5000, placement: "topCenter" }
    );
  }

  getCookie = (name) => {
    const cookies = document.cookie
      .split("; ")
      .find((row) => row.startsWith(`${name}=`));

    return cookies ? cookies.split("=")[1] : null;
  };

  componentDidMount() {
    this.setState({ refer: this.myRef.current });
  }

  convertToPdf = () => {
    const content = this.myRef.current;
    html3pdf().set(options).from(content).save();
  };

  handleInputCurp = (e) => {
    var newValue = e.target.value.toUpperCase();
    this.setState({ curp: newValue });
  };

  async getDataCurp() {
    const abortController = new AbortController();

    if (!this.state.curp) {
      this.toast("Debes escribir un valor antes de continuar", "warning");
      return;
    }

    var url = `Registro/GetData/${this.state.curp}`;
    this.setState({ loading: true });

    try {
      await axios
        .get(url, { signal: abortController.signal })
        .then((response) => {
          this.setState({ lblCurp: this.state.curp });
          this.setState({ fecha: response.data.fecha });
          this.setState({ nombre: response.data.nombre });
          this.setState({ categoria: response.data.categoria });
          this.setState({ equipo: response.data.equipo });
          this.setState({ edad: response.data.edad });
          this.setState({ clave: response.data.clave });
          this.setState({ numero: response.data.numero });
          this.setState({ tel: response.data.tel });
          this.setState({ fecNac: response.data.fecNac });
          this.setState({ loading: false });
          this.setState({ disabledPdf: false });
          this.setState({ display: "block" });
        })
        .catch((err) => {
          this.setState({ disabledPdf: true });
          this.setState({ loading: false });
          this.setState({ display: "none" });
          this.toast("La CURP no existe, en el registro de participantes");
        });
    } catch (error) {
      this.setState({ loading: false });
      if (abortController.signal.aborted) {
        console.log("Data fetching cancelled");
      } else {
        this.setState({ loading: false });
        // Handle error
        this.toast("Ha ocurrido un error", "error");
      }
    }
  }

  async saveDescarga() {
    if (!this.state.curp) {
      return;
    }

    axios
      .put("Registro/UpdateCartaResp", {
        curp: this.state.curp,
      })
      .then((response) => {
        if (response.data === 1) {
          console.log("OK");
        }
      })
      .catch((err) => console.log(err));
  }

  render() {
    const {
      disabledBtn,
      loading,
      fecha,
      nombre,
      categoria,
      fecNac,
      edad,
      clave,
      curp,
      equipo,
      numero,
      tel,
      display,
      disabledPdf,
      lblCurp,
      logo,
      pista
    } = this.state;
    return (
      <div
        style={{
          backgroundImage: "url(Images/datosCarrera.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "100%",
          height: "auto",
          top: 0,
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <div className="App container">
          <center>
            <Image src={`Images/Logo.jpg?v=${new Date().getTime()}`} width={"180px"} height={"180px"} />
          </center>
          <React.Fragment>
            <Container>
              <Header
                style={{
                  backgroundColor: "#f9f7f6",
                  height: "auto",
                  padding: "5px",
                  borderRadius: "15px",
                }}
              >
                <div class="text-center col">
                  <Heading level={3}>Descarga de Carta Responsiva</Heading>
                </div>
              </Header>
              <br></br>
              <div className="row">
                <div className="col-lg-2 col-md-2 col-sm-2">
                  <Input
                    placeholder="CURP"
                    name="CURP"
                    id="curp"
                    autoFocus
                    onInput={this.handleInputCurp}
                    value={curp}
                  />
                </div>
                <div className="col-lg-1 col-md-1 col-sm-1">
                  <Button
                    appearance="primary"
                    className="w-100"
                    loading={loading}
                    disabled={disabledBtn}
                    onClick={() => this.getDataCurp()}
                  >
                    Buscar
                  </Button>
                </div>
                <div className="col-lg-1 col-md-1 col-sm-1">
                  <Button
                    appearance="primary"
                    style={{ width: "100%" }}
                    onClick={this.convertToPdf}
                    disabled={disabledPdf}
                  >
                    Descargar
                  </Button>
                </div>
              </div>
              <br></br>
              {/* CARTA RESPONSIVA */}
              <div
                id="divCarta"
                style={{ display: `${display}`, backgroundColor: 'white' }}
                ref={this.myRef}
              >
                <br></br>
                <div
                  className="App container table-responsive"
                  style={{ border: "solid 1px" }}
                >
                  <div className="row mb-2">&nbsp;</div>
                  <div className="row">
                    <center>
                      <Image
                        src={`Images/Logo1.jpg?v=${new Date().getTime()}`}
                        width={"100px"}
                        height={"100px"}
                      />
                    </center>
                  </div>
                  <div className="row mb-1">&nbsp;</div>
                  <div className="row mb-2">
                    <div className="col">
                      <b>S.L.P. A </b>&nbsp; {fecha}
                    </div>
                  </div>
                  <br></br>
                  <div className="row mb-2">
                    <div className="col">
                      <table style={{ width: "100%" }} className="table">
                        <tr>
                          <td style={{ width: "10%" }}>
                            <b>NOMBRE:</b>
                          </td>
                          <td
                            style={{ borderBottom: "solid 1px", width: "28%" }}
                          >
                            {nombre}
                          </td>
                          <td style={{ width: "5%" }}>
                            <b>EDAD:</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>{edad}</td>
                          <td>
                            <b>EQUIPO:</b>
                          </td>
                          <td
                            style={{ borderBottom: "solid 1px", width: "25%" }}
                          >
                            {equipo}
                          </td>
                        </tr>
                        <tr>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <b>CATEGORÍA</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>
                            {categoria}
                          </td>
                          <td>
                            <b>CLAVE:</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>{clave}</td>
                          <td>
                            <b>NUMERO:</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>
                            {numero}
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <b>FEC. NAC:</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>
                            {fecNac}
                          </td>
                          <td>
                            <b>CURP:</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>
                            {lblCurp}
                          </td>
                          <td>
                            <b>TEL:</b>
                          </td>
                          <td style={{ borderBottom: "solid 1px" }}>{tel}</td>
                        </tr>
                        <tr>
                          <td colSpan={5}>&nbsp;</td>
                        </tr>
                        <tr>
                          <td colSpan={5}>&nbsp;</td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            __________________________________________________________
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={3}>
                            NOMBRE Y FIRMA DEL CORREDOR(A) <br></br>DEL PADRE O
                            TUTOR EN CASO DE SER MENOR DE EDAD
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={5}>&nbsp;</td>
                        </tr>
                        <tr>
                          <td colSpan={5}>&nbsp;</td>
                        </tr>
                        <tr>
                          <td colSpan={6}>
                            <b>
                              EXONERACIÓN DEL EVENTO - CARRERA {pista}
                            </b>{" "}
                            <br></br>
                            {/* LICIVILLA */}
                            Entiendo que en todo evento o actividad deportiva
                            existen riesgos, por ello tengo la firme intención
                            de ser responsable de mí mismo, de mi cuidado
                            personal, de mis actitudes y de mis conductas dentro
                            del evento. Absuelvo al Comité Organizador de este
                            evento o actividad, de toda responsabilidad
                            derivadas de enfermedad, alergias, lesiones y daños
                            que pueda sufrir como resultado de mi participación,
                            tanto en traslados como en los espacios e
                            instalaciones utilizados en el evento. También doy
                            fe de que estoy en condiciones físicas adecuadas,
                            tengo suficiente preparación para participar y mi
                            condición de salud ha sido verificada recientemente
                            por un médico. No obstante, doy mi consentimiento
                            para que mis familiares, tomen las medidas y hagan
                            los arreglos que consideren necesarios y
                            convenientes para mi salud y mi bienestar, si se
                            presentara alguna contingencia.
                            
                            {/* SERIAL MTB 
                            Por medio del presente documento, en mi carácter de participante en el “RETO LA PRECIOSA HDSPM” declaro
                            que:
                            Estoy completamente consciente de que realizar actividades deportivas implica un riesgo de accidentes y/o lesiones.
                            Doy fe de que yo (nombre completo):
                            Me encuentro en excelentes condiciones físicas y puedo participar en toda actividad física y deportiva relacionada con
                            el <b>{pista}</b>; asimismo, dado que me están permitiendo participar en esta competencia, estoy
                            de acuerdo de asumir la completa responsabilidad y riesgo de cualquier lesión que pueda resultar de mi participación
                            en dicho evento.
                            En caso de tener una situación médica relacionada con mi salud preexistente como alergias, enfermedad, etc. que
                            potencialmente me pudiera prohibir o limitar mi participación en estos eventos, declaro que dichos padecimientos
                            son:
                            Adicionalmente, eximo, deslindo y estoy de acuerdo en no levantar ninguna demanda por ninguna causa a ninguno
                            de los organizadores o staff del <b>{pista}</b> , ni a ninguno de sus empleados, oficiales,
                            contratantes, socios, agentes, afiliados, voluntarios; esto incluye a mi persona y mi familia, por cualquier daño, robo,
                            lesión personal, muerte accidental o cualquier otra situación que pueda resultar de mi participación en esta
                            competencia (y que posiblemente haya podido ser causada por negligencia de alguna de las partes mencionadas en
                            este párrafo en cualquier momento que haya sucedido), Juro ser la persona mencionada en este documento, o el tutor,
                            padre o madre de dicha persona, y ejecuto esta carta responsiva por mi propia cuenta. Estoy de acuerdo con los
                            términos y condiciones de esta carta responsiva y que estoy sujeto a los mismos. Soy mayor de edad y estoy firmando
                            este documento libremente y de mi propia voluntad, sin la coerción de otras personas o instituciones.
                            Entiendo que el practicar deporte o actividades físicas específicamente el ciclismo de montaña viene con un riesgo
                            relacionado de lesiones personales. Con respecto a lo mismo, voluntariamente doy permiso y autorizo que yo participe
                            en <b>{pista}</b>, estoy de acuerdo en asumir dicho riesgo y responsabilidad completamente de
                            cualquier lesión y daño que resulte de mi participación.
                            He leído el documento y lo entiendo perfectamente; al firmarlo, estoy cediendo mis derechos legales relacionados con
                            este evento.
                            <br></br>
                            Firma de Padre, madre o tutor
                            Nombre completo:
                            Fecha
                            Celular:
                            Firma y nombre de Participantes (si es mayor de edad)
                            email:
                            Fecha:
                            Celular:
                            Numero de contacto en caso de emergencia:
                            En la Comunidad de la San José de Gómez en el municipio de Zaragoza a los
                            días
                            del mes de
                            del año 2025 dos mil veinticinco.*/}
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <br></br>
              <Button
                          appearance="ghost"
                          className="w-100"
                          color="blue"
                          style={{ border: "none", fontSize: "22px" }}
                          onClick={() => {
                            window.history.go(-1);
                          }}
                        >
                          Regresar...
                        </Button>
              <br></br>
            </Container>
          </React.Fragment>
        </div>
        <div className="row mb-4" style={{height: '390px'}}>&nbsp;</div>
      </div>
    );
  }
}
